import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;

//查询排班列表
export const getAppointmentList = (data) => {
  return axios.post(`${base}/api/Appointment/PostSelectAppointmentList`, data);
};
// 新增排班
export const addAppointment = (data) => {
  return axios.post(`${base}/api/Appointment/PostAddAppointment`, data);
};
//删除排班
export const deleteAppointment = (params) => {
  return axios.delete(`${base}/api/Appointment/DeleteAppointment`, {
    params: params,
  });
};
//批量删除排班
export const batchDeleteAppointment = (data) => {
  return axios.post(`${base}/api/Appointment/DeleteBatchAppointment`, data);
};

//修改排班
export const updateAppointment = (data) => {
  return axios.post(`${base}/api/Appointment/PostUpdateAppointment`, data);
};
